import React from 'react';
import { AppLayout as BaseAppLayout, IE11Banner } from '@ui/wrapper';
import { Header } from './components/Header';
import { OnlyfyOnboardingDialog } from '@ui/core/popups';

export type HeaderProps = {
  userName: string;
  userAvatarUrl: string;
  userCompany: string;
  userEmail: string;
};

export type AppLayoutProps = {
  headerProps: HeaderProps;
};

/**
 * General layout consumed by every page in XTS
 * Injected via src_new/screens/BaseScreen/BaseScreen.tsx
 */
export const AppLayout: React.FC<AppLayoutProps> = ({
  headerProps,
  children,
}) => {
  return (
    <>
      <IE11Banner />
      <OnlyfyOnboardingDialog />
      <BaseAppLayout id="AppLayout" overflow="hidden">
        <BaseAppLayout.Header>
          <Header {...headerProps} />
        </BaseAppLayout.Header>
        <BaseAppLayout.Body>
          <BaseAppLayout.Content width="100%">{children}</BaseAppLayout.Content>
        </BaseAppLayout.Body>
      </BaseAppLayout>
    </>
  );
};
